import React, { forwardRef } from 'react';
import { motion } from 'framer-motion';

export const Reveal = forwardRef(({ children, delay = 0, y = 28, className = '', viewportAmount = 0.2, ...rest }, ref) => (
  <motion.div
    ref={ref}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: viewportAmount }}
    transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
));

export const FadeIn = forwardRef(({ children, delay = 0, className = '', ...rest }, ref) => (
  <motion.div
    ref={ref}
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    transition={{ duration: 0.5, delay, ease: 'easeOut' }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
));

const staggerContainerVariants = {
  hidden: {},
  show: {
    transition: { staggerChildren: 0.1 },
  },
};

const staggerItemVariants = {
  hidden: { opacity: 0, y: 24 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5, ease: [0.22, 1, 0.36, 1] } },
};

export const StaggerGroup = forwardRef(({ children, className = '', viewportAmount = 0.15, ...rest }, ref) => (
  <motion.div
    ref={ref}
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, amount: viewportAmount }}
    variants={staggerContainerVariants}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
));

export const StaggerItem = forwardRef(({ children, className = '', ...rest }, ref) => (
  <motion.div ref={ref} variants={staggerItemVariants} className={className} {...rest}>
    {children}
  </motion.div>
));

export const HoverLift = forwardRef(({ children, className = '', lift = -6, scale = 1, ...rest }, ref) => (
  <motion.div
    ref={ref}
    whileHover={{ y: lift, scale }}
    transition={{ duration: 0.25, ease: 'easeOut' }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
));

export const PressableButton = forwardRef(({ children, className = '', ...rest }, ref) => (
  <motion.button
    ref={ref}
    whileHover={{ y: -2 }}
    whileTap={{ scale: 0.96 }}
    transition={{ duration: 0.18, ease: 'easeOut' }}
    className={className}
    {...rest}
  >
    {children}
  </motion.button>
));
